export const routes  = (prefix = `suppliers-dashboard`) => [
    {
        path: `/${prefix}/approvals`,
        name: `${prefix}.approvals.index`,
        component: () => import('./Index.vue'),
        meta: {
            requiresAuth: true,
            permissions: {
                PageName: `${prefix}`,
                PageDescription: "Supplier module: Approvals",
            },
        },
    },
];